import FeeTable from "./FeeTable";
import { useGetFeeDetails } from "./hooks/useGetFeeDetails";
import "./FeeDetails.css";

const FeeDetails = () => {
  const { data } = useGetFeeDetails();
  console.log("data", data);
  return (
    <div className="fee-details-container">
      <FeeTable data={data?.data} />
    </div>
  );
};

export default FeeDetails;
